import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'

import { connect } from 'react-redux'

import { displayNumber } from '../../../utils'
import ModalConfirmation from '../modalConfirmation'

import * as actions from '../../../actions'

class CreateConsents extends Component {
  state = {
    dryRun: true
  }

  componentDidMount () {
    this.props.createConsents(true)
  }

  _renderDryRun () {
    const { driversBulkActions: { loading, error, createdConsents } } = this.props

    if (loading || !createdConsents) {
      return <ModalConfirmation
        show={true}
        header='Create new consent requests'
        text='Preparing to create consent requests...'
        loading={loading}
        error={error}
        showAccept={false}
        onCancel={() => this.props.done()}
      />
    }
    if (createdConsents && createdConsents.created && createdConsents.emailed) {
      const { count } = createdConsents.created
      if (count === 0) {
        return <ModalConfirmation
          show={true}
          header='Create new consent requests'
          text='There are no drivers in your selection for whom a consent request can be created.'
          loading={loading}
          error={error}
          showAccept={false}
          cancelText='Done'
          onCancel={() => this.props.done()}
        />
      }
      return <ModalConfirmation
        show={true}
        header='Create new consent requests'
        text={`New consent requests will be created for ${displayNumber(count)} drivers. \
          Of these, ${displayNumber(createdConsents.emailed.count)} drivers have email addresses and will be notified. Do you want to proceed?`}
        loading={loading}
        error={error}
        onAccept={() => this.setState({ dryRun: false }, () => this.props.createConsents(false)) }
        onCancel={() => this.props.done()}
      />
    }
    return ''
  }

  _renderConfirmedRun () {
    const { driversBulkActions: { loading, error, createdConsents } } = this.props

    let text = ''
    if (loading || !createdConsents) {
      text = 'Creating consents...'
    } else if (createdConsents && createdConsents.created && createdConsents.emailed) {
      text = `New consents have been created for ${displayNumber(createdConsents.created.count)} drivers. \
      Of these, ${displayNumber(createdConsents.emailed.count)} drivers were emailed a notification.`
    }

    return <ModalConfirmation
      show={true}
      header='Create new consent requests'
      text={text}
      loading={loading}
      error={error}
      showAccept={false}
      cancelText='Done'
      onCancel={() => this.props.done()}
    />
  }

  render () {
    const { dryRun } = this.state
    return dryRun ? this._renderDryRun() : this._renderConfirmedRun()
  }
}

const mapStateToProps = (state) => {
  const { driversBulkActions } = state
  return { driversBulkActions }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    { ...actions.driversBulkActions },
    dispatch
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateConsents)

CreateConsents.propTypes = {
  done: PropTypes.func.isRequired,
  driversBulkActions: PropTypes.object.isRequired,
  createConsents: PropTypes.func.isRequired
}
